// extracted by mini-css-extract-plugin
module.exports = {"icon":"Navbar_icon__3hgHL","navbar":"Navbar_navbar__3a_hF"};